module.exports = __webpack_public_path__ + "img/bloodExplain.46de2e4c.png";